import { ActionsUnion } from "../../type/actionsUnion"
import createAction from "../../type/createAction"
import { StoreState } from "../StoreState"
import { ServerConfiguration } from "../../type/serverConfiguration"
import { TEndpointName } from "../../type/request/IApiEndpoint"

export type ConfigurationState = Readonly<{
    serverConfiguration?: ServerConfiguration
    initialized: boolean
}>
const initialState: ConfigurationState = { serverConfiguration: undefined, initialized: false }

export const configurationReducerActions = {
    setServerConfiguration: (serverConfiguration: ServerConfiguration) =>
        createAction("APP/SET_SERVER_CONFIGURATION", { serverConfiguration }),
    setInitialized: (initialized: boolean) => createAction("APP/SET_INITIALIZED", { initialized }),
}

export type ConfigurationActions = ActionsUnion<typeof configurationReducerActions>

export const configurationReducer = (
    state: ConfigurationState = initialState,
    action: ConfigurationActions
): ConfigurationState => {
    switch (action.type) {
        case "APP/SET_SERVER_CONFIGURATION": {
            return {
                ...state,
                serverConfiguration: action.serverConfiguration,
            }
        }
        case "APP/SET_INITIALIZED": {
            return {
                ...state,
                initialized: action.initialized,
            }
        }
    }

    return state
}

export const configurationSelectors = {
    serverConfiguration: (state: StoreState) => state.configuration.serverConfiguration!,
    environment: (state: StoreState) => state.configuration.serverConfiguration?.environment ?? "Production",
    endpointConfig: (state: StoreState, endpointName: TEndpointName): string => {
        const origins = state.configuration.serverConfiguration?.origins
        if (!origins) {
            return ""
        }
        return origins[endpointName]
    },
    initialized: (state: StoreState) => !!state.configuration.serverConfiguration && state.configuration.initialized,
}
